import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { t } from "i18next";
import '@/styles/modal.scss';

interface MessageModalProps {
    open: boolean;
    onClose: () => void;
    title?: string;
    message?: string;
    buttonText?: string;
    onButtonClick?: () => void;
    showButton?: boolean;
}

const MessageModal = ({
    open,
    onClose,
    title = t("Success"),
    message = t("Operation completed successfully."),
    buttonText = t("OK"),
    onButtonClick,
    showButton = false
}: MessageModalProps) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    minWidth: { xs: 'auto', sm: 400 },
                    maxWidth: { xs: 'calc(100% - 32px)', sm: 600 },
                    margin: { xs: 2, sm: 3 },
                    maxHeight: { xs: 'calc(100% - 32px)', sm: 'calc(100% - 64px)' },
                }
            }}
            slotProps={{
                paper: {
                    className: 'modal-dialog'
                }
            }}
        >
            <Box className="modal-header">
                <DialogTitle className="modal-header-title">
                    {title}
                </DialogTitle>
                <IconButton
                    onClick={onClose}
                    className="modal-close-button"
                    aria-label="Close"
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Box>
            <DialogContent dividers className="modal-content-padded">
                <Typography variant="subtitle1" gutterBottom className="modal-main-content">
                    {message}
                </Typography>
                {showButton && (
                    <Box className="modal-mt-3 modal-text-center">
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={onButtonClick || onClose}
                            className="modal-button-base modal-button-primary"
                        >
                            {buttonText}
                        </Button>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    )
}

export default MessageModal;
